import {useRef} from 'react';

export default function useTestableRef(initialValue = null) {
  return useRef(initialValue);
}
